<script setup lang="ts">
import type { CarsListCar } from '@autobid/ui/types/Car'
import { useCarCountdown } from '@autobid/ui/composables/car/countdown/useCarCountdown'
import { useAuction } from '@autobid/ui/composables/useAuction'
import { computed } from 'vue'

interface Props {
  car: CarsListCar
}

const props = defineProps<Props>()
const { auction } = useAuction(props.car.auctionId)
const { timeRemaining, isCountdownOver } = useCarCountdown(
  computed(() => props.car),
)
</script>

<template>
  <span class="mr-3.5 inline-block text-accordion-primary sm:mr-6">
    {{ $t('cars-list.number-shortcut') }}: {{ car.catalogNumber }}
  </span>

  <template v-if="car.stage === 'IN_AUCTION'">
    <span
      class="auction-label relative z-0 mr-4 inline-flex items-center bg-success pl-3 pr-2 text-xs text-white after:absolute after:rotate-45 after:bg-success"
    >
      <span class="relative z-10">
        {{
          $t(
            car.inActiveHotbidPhase
              ? 'shared-car.hotbid'
              : 'cars-list.in-auction',
          )
        }}
      </span>
    </span>

    <span
      v-if="!isCountdownOver || auction?.isPaused"
      class="text-bold mr-2 inline-block text-lg text-success"
    >
      <template v-if="!isCountdownOver && !auction?.isPaused">
        <span class="hidden sm:inline-block">{{ timeRemaining.full }}</span>
        <span class="sm:hidden">{{ timeRemaining.short }}</span>
      </template>
      <template v-else-if="auction?.isPaused">
        <span>{{ $t('shared-car.hotbid-starts-soon') }}</span>
      </template>
    </span>
  </template>
</template>

<style lang="scss" scoped>
.auction-label {
  height: 22px;

  &::after {
    width: 16px;
    height: 16px;
    top: 3px;
    right: -9px;
  }
}
</style>
